import { Options } from '@sheerid/jslib';
import { messagesEN } from './lib/intl/en-US';
import { RecursivePartial } from './lib/types/types';


export const programId = '624db51f23073744664b1674';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    // TODO - change to 'error' before going live
    logLevel: 'info',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
};
